var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner bg-white"},[_c('div',{staticClass:"content content-padding"},[_c('div',{staticClass:"text-020814 font-40"},[_vm._v("了解数智社区最新动态")]),_c('div',{staticClass:"font-weight-400 font-16 text-41464F margin-top-6"},[_vm._v("关注最新动态，读懂社区未来")]),_c('div',{staticClass:"box padding-top-64"},[_c('swiper')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }